import {
  colors,
  ImpCard,
  ImpContainer,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { useImpState } from '../../app/hooks';
import { FORM_BUTTON_WIDTH } from '../../assets/consts/const';
import Spinner from '../../components/spinner/Spinner';
import OnboardingLayout from './OnboardingLayout';

export interface OnboardingCompleteContent {
  title: string;
  subtitle: string;
}

export interface OnboardingCompletePageProps {
  content: OnboardingCompleteContent;
  onNext: () => void;
}

const REDIRECT_DELAY_MS = 3000;

export default function OnboardingCompletePage({
  content,
  onNext,
}: OnboardingCompletePageProps) {
  const { merchantData } = useImpState();

  useEffect(() => {
    const timer = setTimeout(() => {
      onNext();
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OnboardingLayout>
      <ImpSpacer height="l" />
      <ImpCard src={merchantData.cardImg} width={FORM_BUTTON_WIDTH} />
      <ImpSpacer height="xl" />
      <ImpContainer width={FORM_BUTTON_WIDTH} textAlign="center">
        <ImpText typography="headline3">{content.title}</ImpText>
        <ImpSpacer height="xs" />
        <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
          {content.subtitle.replaceAll(
            '{merchantName}',
            merchantData.rewardDetails.merchantName
          )}
        </ImpText>
      </ImpContainer>
      <ImpSpacer height="l" />
      <Spinner />
    </OnboardingLayout>
  );
}
